import React from 'react';
import { HiShieldCheck } from '@react-icons/all-files/hi/HiShieldCheck';

const VisitorEngagement: React.FC = () => {
  return (
    <section
      id='visitor-engagement'
      className='container bg-[#cbd9ff] max-w-full px-10 py-12 mx-auto md:px-20'
    >
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <h2 className='mb-4 font-medium uppercase text-md'>
          Visitor Engagement
        </h2>
        <strong className='text-2xl md:text-3xl font-bold'>
          Great for these spaces:
        </strong>
        {/* Grid Items */}
        <div className='grid items-center justify-center grid-cols-1 md:mx-2 my-10 md:grid-cols-2 gap-x-10 gap-y-10'>
          {/* Grid Item 1 */}
          <div className='flex flex-col'>
            <div className='flex flex-row items-center justify-start text-lg'>
              <HiShieldCheck className='text-3xl' />
              <p className='ml-3 text-xl font-semibold'>Cities, Towns & Botanical Gardens</p>
            </div>
            <div className='flex flex-col'>
              <p className='my-2 text-lg mx-11'>
                Offer audio-guided walking tours, display instant translation up to 96 languages, and gather heat-mapping data for footstep analysis
              </p>
            </div>
          </div>

          {/* Grid Item 2 */}
          <div className='flex flex-col'>
            <div className='flex flex-row items-center justify-start text-lg'>
              <HiShieldCheck className='text-3xl' />
              <p className='ml-3 text-xl font-semibold'>Wildlife Parks & Zoos</p>
            </div>
            <div className='flex flex-col'>
              <p className='my-2 text-lg mx-11'>
                Design scavenger hunts for school groups, curate meaningful donation requests, and customize on + offsite partnership promotions
              </p>
            </div>
          </div>

          {/* Grid Item 3 */}
          <div className='flex flex-col'>
            <div className='flex flex-row items-center justify-start text-lg'>
              <HiShieldCheck className='text-3xl' />
              <p className='ml-3 text-xl font-semibold'>Science, Art & History Museums</p>
            </div>
            <div className='flex flex-col'>
              <p className='my-2 text-lg mx-11'>
                Build rotating exhibit walkthroughs, offer behind-the-scenes videos, and automate scheduled events and VIP experience content
              </p>
            </div>
          </div>

          {/* Grid Item 4 */}
          <div className='flex flex-col'>
            <div className='flex flex-row items-center justify-start text-lg'>
              <HiShieldCheck className='text-3xl' />
              <p className='ml-3 text-xl font-semibold'>Cultural Attractions, Venues and more!</p>
            </div>
            <div className='flex flex-col'>
              <p className='my-2 text-lg mx-11'>
                Enhance visitor engagement, capture feedback and gather analytics in any space
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisitorEngagement;
